import React, { Component } from 'react';
import './Abouttfjs.css';

/**
 * Class to handle the rendering of the Home page.
 * @extends React.Component
 */
export default class Home extends Component {
  render() {
    return (
      <div className="About container">
        <h1>About: TensorFlow.js Classfier</h1>
        <p>
          This is a TensorFlow.js web application where users can classify images selected locally
          or taken with their device's camera. The app uses TensorFlow.js and a pre-trained model (
          <a href="https://www.tensorflow.org/api_docs/python/tf/keras/applications/MobileNetV2">MobilenetV2 pertrained on ImageNet </a> ) converted to the TensorFlow.js format to provide the inference capabilities.
          This pre-trained model is saved locally in your browser using IndexedDB. A service worker is also used
          to provide offline capabilities. This option also provides better privacy and potentially a lower latency. 
        </p>
		    <p>Adapted from an Tensorflow.JS <a href="https://github.com/IBM/tfjs-web-app">Repository by IBM</a> which is licensed under the Apache Software License, Version 2. </p>
        <p> &copy; 2020 Michael Feil. Apache Software License, Version 2.</p>
      </div>
    );
  }
}
